import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/juwie_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-69d78a2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("h1", null, "Giveaway Central")
], -1))
const _hoisted_2 = { class: "nav-menu" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Home ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Criar novo sorteio ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Sorteios correntes ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Histórico de sorteios ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Configurações ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/home" }, {
        default: _withCtx(() => [
          _createVNode(_component_font_awesome_icon, {
            class: "font-awesome-icon",
            icon: "fa-duotone fa-home-user"
          }),
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/create-giveaway" }, {
        default: _withCtx(() => [
          _createVNode(_component_font_awesome_icon, {
            class: "font-awesome-icon",
            icon: "fa-duotone fa-hand-holding-box"
          }),
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/running-giveaways" }, {
        default: _withCtx(() => [
          _createVNode(_component_font_awesome_icon, {
            class: "font-awesome-icon",
            icon: "fa-duotone fa-stopwatch"
          }),
          _hoisted_5
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/history" }, {
        default: _withCtx(() => [
          _createVNode(_component_font_awesome_icon, {
            class: "font-awesome-icon",
            icon: "fa-duotone fa-clock-rotate-left"
          }),
          _hoisted_6
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/settings" }, {
        default: _withCtx(() => [
          _createVNode(_component_font_awesome_icon, {
            class: "font-awesome-icon",
            icon: "fa-duotone fa-toolbox"
          }),
          _hoisted_7
        ]),
        _: 1
      })
    ])
  ], 64))
}